"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Nav_1 = require("./Nav");
exports.isNavType = function (child) {
    var asReactElement = child;
    return Boolean(asReactElement && asReactElement.type === Nav_1.Nav);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-sidenav/nav/isNavType.js
// module id = ./node_modules/react-sidenav/nav/isNavType.js
// module chunks = 0